export const createUniqueId = (size = 30) => {
  let id = "";
  for (let i = 0; i < size; i++) {
    const character = Math.round(Math.random() * (60 - 0));
    id = `${id}${characters[character]}`;
  }

  return id;
};

const characters = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const getFormatDate = (unixTime) => {
  const date = new Date(unixTime * 1000);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatToMexicoUTC = (dateString) => {
  const dateUTC = new Date(dateString);

  const mexicoDate = new Date(dateUTC.getTime() - 6 * 60 * 60 * 1000);

  const pad = (n) => n.toString().padStart(2, "0");

  const day = pad(mexicoDate.getUTCDate());
  const month = pad(mexicoDate.getUTCMonth() + 1);
  const year = mexicoDate.getUTCFullYear();

  const hours = pad(mexicoDate.getUTCHours());
  const minutes = pad(mexicoDate.getUTCMinutes());

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export function getDayInMexico(utcDateString) {
  const date = new Date(utcDateString);

  const mexicoOffsetMs = -6 * 60 * 60 * 1000;
  const mexicoDate = new Date(date.getTime() + mexicoOffsetMs);

  const days = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];

  return days[mexicoDate.getUTCDay()];
}

export const unixTimestamp = () => Math.floor(Date.now() / 1000);
